import { useEffect } from 'react'

const DEFAULT_SOCIAL_IMAGE = '/images/branding/social/main_logo_1200x600.png'
const DEFAULT_SOCIAL_IMAGE_ALT = 'Blazin Welding & Fabrication LLC — 425.750.6340'

function setMeta(selector, attribute, value) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    const [name, key] = selector.includes('property=') ? ['property', selector.match(/property="([^"]+)/)?.[1]] : ['name', selector.match(/name="([^"]+)/)?.[1]]
    if (key) element.setAttribute(name, key)
    document.head.appendChild(element)
  }
  element.setAttribute(attribute, value)
}

export function usePageMeta({ title, description, path = '/', image = DEFAULT_SOCIAL_IMAGE, imageAlt = DEFAULT_SOCIAL_IMAGE_ALT }) {
  useEffect(() => {
    const origin = window.location.origin
    const canonicalUrl = new URL(path, origin).toString()
    const imageUrl = image ? new URL(image, origin).toString() : null
    document.title = title
    setMeta('meta[name="description"]', 'content', description)
    setMeta('meta[property="og:title"]', 'content', title)
    setMeta('meta[property="og:description"]', 'content', description)
    setMeta('meta[property="og:type"]', 'content', 'website')
    setMeta('meta[property="og:url"]', 'content', canonicalUrl)
    setMeta('meta[property="og:site_name"]', 'content', 'Blazin Welding & Fabrication LLC')
    setMeta('meta[property="og:locale"]', 'content', 'en_US')
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image')
    setMeta('meta[name="twitter:title"]', 'content', title)
    setMeta('meta[name="twitter:description"]', 'content', description)
    if (imageUrl) {
      setMeta('meta[property="og:image"]', 'content', imageUrl)
      setMeta('meta[property="og:image:secure_url"]', 'content', imageUrl)
      setMeta('meta[property="og:image:type"]', 'content', 'image/png')
      setMeta('meta[property="og:image:width"]', 'content', '1200')
      setMeta('meta[property="og:image:height"]', 'content', '600')
      setMeta('meta[property="og:image:alt"]', 'content', imageAlt)
      setMeta('meta[name="twitter:image"]', 'content', imageUrl)
      setMeta('meta[name="twitter:image:alt"]', 'content', imageAlt)
    }
    let canonical = document.head.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = canonicalUrl
  }, [title, description, path, image, imageAlt])
}
